module.exports = __webpack_public_path__ + "8aef85356b029d34e1988155100610fe.png";